import GetStartedStage from '@/views/stages/GetStartedStage';
import QuestionnaireStage from '@/views/stages/QuestionnaireStage';
import UploadsStage from '@/views/stages/UploadsStage';
import StudySetup from '@/views/stages/StudySetup.vue';
import store from '@/store';

export default [
   {
      path: '/get-started',
      name: 'get-started-stage',
      component: GetStartedStage,
      meta: {
         authGroup: 'client',
         stage: 'get-started',
         allowUnconfigured: true,
         allowUngreeted: true,
      },
   },
   {
      path: '/uploads',
      name: 'uploads-stage',
      component: UploadsStage,
      meta: {
         authGroup: 'client',
         stage: 'uploads',
         allowUnconfigured: true,
      },
   },
   {
      path: '/study-setup',
      name: 'study-setup',
      component: StudySetup,
      beforeEnter: (to, from, next) => {
         if (to.params.shouldOpenTaxReturnModal) {
            store.commit('setTaxReturnModalOpened', true);
         }
         next();
      },
      meta: {
         authGroup: 'client',
         stage: 'study-setup',
         allowUnconfigured: true,
      },
   },
   {
      path: '/questionnaires',
      name: 'questionnaires',
      component: QuestionnaireStage,
      meta: {
         authGroup: 'client',
         stage: 'questionnaire',
      },
   },
];
